import { array, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Direction } from './Direction';

export const Request = <T extends string>(fieldNames: readonly T[]) =>
	array(
		struct({
			field: iotsUtils.fromList(fieldNames),
			direction: Direction,
		})
	);
